var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbIco2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 54",
    style: {
      enableBackground: "new 0 0 56 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.46,2.4H7.54c-2.35,0-4.25,1.9-4.25,4.25v14.2c0,2.35,1.9,4.25,4.25,4.25h40.92c2.35,0,4.25-1.9,4.25-4.25 V6.65C52.71,4.3,50.81,2.4,48.46,2.4z M48,19.23c0,0.78-0.63,1.42-1.42,1.42H9.42C8.64,20.65,8,20.02,8,19.23V8.27 c0-0.78,0.63-1.42,1.42-1.42h37.16c0.78,0,1.42,0.63,1.42,1.42V19.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.98,28.89H7.54c-2.35,0-4.25,1.9-4.25,4.25v14.2c0,2.35,1.9,4.25,4.25,4.25h14.45 c2.35,0,4.25-1.9,4.25-4.25v-14.2C26.24,30.8,24.33,28.89,21.98,28.89z M21.52,45.73c0,0.78-0.63,1.42-1.42,1.42H9.42 C8.64,47.15,8,46.51,8,45.73V34.77c0-0.78,0.63-1.42,1.42-1.42H20.1c0.78,0,1.42,0.63,1.42,1.42V45.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.46,28.89H34.02c-2.35,0-4.25,1.9-4.25,4.25v14.2c0,2.35,1.9,4.25,4.25,4.25h14.45 c2.35,0,4.25-1.9,4.25-4.25v-14.2C52.71,30.8,50.81,28.89,48.46,28.89z M48,45.73c0,0.78-0.63,1.42-1.42,1.42H35.9 c-0.78,0-1.42-0.63-1.42-1.42V34.77c0-0.78,0.63-1.42,1.42-1.42h10.69c0.78,0,1.42,0.63,1.42,1.42V45.73z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco2);
export default __webpack_public_path__ + "static/media/gnb_ico2.fc1ad03feb0ffdc41678bce25e77627f.svg";
export { ForwardRef as ReactComponent };